import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { coloresEmma } from '../../../global/js/funciones';
import cargandoImg from '../../../global/imagenes/cargando.png';
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    margin: "auto",
    textAlign: "center",
  },
  loadingImage: {
    width: 64,
    height: 64,
    objectFit: 'contain',
    animation: '$spin 1.1s linear infinite',
    // Tiñe la imagen al rojo institucional para mantener consistencia visual.
    filter: 'brightness(0) saturate(100%) invert(14%) sepia(73%) saturate(5146%) hue-rotate(355deg) brightness(84%) contrast(104%)',
  },
  Typography: {
    color: '#9e9e9e',
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
});


export default function Cargando({ width = "80%", marginTop = "300px", texto = "Cargando..." }) {
  const classes = useStyles();
  return (
    <div className="Container">
    <div className={classes.root} style={{ width, marginTop, }}>
      <img src={cargandoImg} alt="Cargando" className={classes.loadingImage} />
      <Typography variant="h6" component="h2" className={classes.Typography}>
        {texto}
      </Typography>
    </div>
    </div>
  )

}

